import React, { useState } from "react";
import { ScrollArea, Table } from "@mantine/core";
import Survey from "../services/model/Survey";
import { dateFormat } from "../../../utils/DateTime";
import { useDirectoryTableStyles } from "../../../themes/components/DirectoryTable";
import PageHeading from "../../../themes/components/PageHeading";

type SurveyDataPanelProps = {
  survey: Survey;
};

const SurveyDataPanel: React.FC<SurveyDataPanelProps> = ({ survey }) => {
  const { classes, cx } = useDirectoryTableStyles();
  const [scrolled, setScrolled] = useState(false);

  const rows = new Map();

  const headers: {
    id: number;
    type: string;
    content: string;
    date: string;
  }[] = [];

  survey.questions.forEach((it, index) => {
    it.responses.forEach((response) => {
      const temp =
        rows.get(
          `${response.employee.first_name} ${response.employee.last_name}`
        ) || [];
      rows.set(
        `${response.employee.first_name} ${response.employee.last_name}`,
        [
          ...temp,
          {
            question: it.content,
            date: `${dateFormat(response.date_created)}`,
            respondent: `${response.employee.first_name} ${response.employee.last_name}`,
            answer: `${
              Object.is(it.question_type, "free-text")
                ? response.text_answer
                : response.form_question_choice?.content
            }`,
          },
        ]
      );
    });

    headers.push({
      id: index + 1,
      type: Object.is(it.question_type, "free-text")
        ? "Open-ended"
        : "Multiple choice",
      content: it.content,
      date: it.date_created,
    });
  });

  return (
    <div style={{ padding: "32px 40px" }}>
      <PageHeading title="Responses" />
      <ScrollArea
        sx={{ height: 645, background: "#ffffff" }}
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      >
        <Table highlightOnHover striped verticalSpacing="xs">
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th>Date</th>
              <th>Respondent</th>
              {headers.map((it) => (
                <th key={`tHead-question${it.id}`}>
                  {`${it.id} ${it.type}`} <br /> {it.content}
                </th>
              ))}
            </tr>
          </thead>

          {Array.from(rows.keys()).map((it) => (
            <tr key={`thead-${it}`} className="table-row">
              <td>{rows.get(it)[0].date}</td>
              <td>{it}</td>
              {headers.map((question, index) => (
                <td key={`tRow-${it}`}>
                  {rows.get(it)[index] ? rows.get(it)[index].answer : "-"}
                </td>
              ))}
            </tr>
          ))}
          <tbody />
        </Table>
      </ScrollArea>
    </div>
  );
};

export default SurveyDataPanel;
